
document.addEventListener('DOMContentLoaded' , () =>{
	//공통 main
	if(document.querySelector('.main-page')){
		document.querySelector('.visual').classList.add('on');
	}
});
